import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

import { Config } from '@config/config.service';
import { ROUTES_MAP } from '@config/routes-config';
import { AccountService } from './account.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class NavigationService {
  breadcrumbsMenu = [];

  filterPaginationData = {};

  constructor(
    private config: Config,
    private accountService: AccountService,
    private location: Location,
    private translateService: TranslateService
  ) { }

  setBreadcrumbs(page = '', additionalData?: any): any {
    switch (page) {
      case this.config.pages.dashboard: {
        this.breadcrumbsMenu = [
          {
            link: `/${ROUTES_MAP.profile}/${this.config.pages.dashboard}`,
            name: `${this.accountService.getUser().customerData.name} forsikringstilbud`,
          }
        ];
        break;
      }
      case this.config.pages.invitations: {
        this.breadcrumbsMenu = [
          {
            link: `/${ROUTES_MAP.profile}/${this.config.pages.dashboard}`,
            name: `${this.accountService.getUser().customerData.name} forsikringstilbud`
          },
          {
            link: `/${ROUTES_MAP.profile}/${this.config.pages.invitations}`,
            name: this.translateService.instant('PRODUCT_MENU.INVITATIONS_ALL'),
            queryParamsData: this.getSearchData()
          }
        ];
        break;
      }
      case this.config.pages.sessions: {
        if (!additionalData) {
          this.breadcrumbsMenu = [
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.dashboard}`,
              name: `${this.accountService.getUser().customerData.name} forsikringstilbud`
            },
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.sessions}`,
              name: this.translateService.instant('PRODUCT_MENU.SESSIONS_ALL'),
              queryParamsData: this.getSearchData()
            },
          ];
        } else {
          this.breadcrumbsMenu = [
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.dashboard}`,
              name: `${this.accountService.getUser().customerData.name} forsikringstilbud`
            },
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.sessions}`,
              name: this.translateService.instant('PRODUCT_MENU.SESSIONS_ALL'),
              queryParamsData: this.getSearchData()
            },
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.sessions}/${additionalData.id}`,
              name: `${this.translateService.instant('PRODUCT_MENU.SESSION')} #${additionalData.id}`,
              queryParamsData: this.getSearchData()
            },
          ];
        }
        break;
      }
      case this.config.pages.users: {
        if (!additionalData) {
          this.breadcrumbsMenu = [
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.dashboard}`,
              name: `${this.accountService.getUser().customerData.name} forsikringstilbud`
            },
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.users}`,
              name: this.translateService.instant('PRODUCT_MENU.USERS_ALL'),
              queryParamsData: this.getSearchData()
            },
          ];
        }
        break;
      }
      case this.config.pages.offerData: {
        if (!additionalData) {
          this.breadcrumbsMenu = [
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.dashboard}`,
              name: `${this.accountService.getUser().customerData.name} forsikringstilbud`
            },
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.offerData}`,
              name: this.translateService.instant('PRODUCT_MENU.OFFERS_ALL'),
              queryParamsData: this.getSearchData()
            },
          ];
        } else {
          this.breadcrumbsMenu = [
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.dashboard}`,
              name: `${this.accountService.getUser().customerData.name} forsikringstilbud`
            },
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.offerData}`,
              name: this.translateService.instant('PRODUCT_MENU.OFFERS_ALL'),
              queryParamsData: this.getSearchData()
            },
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.offerData}/${additionalData.id}`,
              name: `${this.translateService.instant('PRODUCT_MENU.OFFER')} #${additionalData.id}`,
              queryParamsData: this.getSearchData()
            },
          ];
        }
        break;
      }

      case this.config.pages.productValidation: {
        if (!additionalData) {
          this.breadcrumbsMenu = [
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.dashboard}`,
              name: `${this.accountService.getUser().customerData.name} forsikringstilbud`
            },
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.productValidation}`,
              name: this.translateService.instant('PRODUCT_MENU.VALIDATION_RULE_ALL'),
              queryParamsData: this.getSearchData()
            },
          ];
        } else {
          this.breadcrumbsMenu = [
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.dashboard}`,
              name: `${this.accountService.getUser().customerData.name} forsikringstilbud`
            },
            {
              link: `/${ROUTES_MAP.profile}/${this.config.pages.productValidation}`,
              name: this.translateService.instant('PRODUCT_MENU.VALIDATION_RULE_ALL'),
              queryParamsData: this.getSearchData()
            },
            {
              link: ``,
              name: `${this.translateService.instant('PRODUCT_MENU.VALIDATION_RULE')} #${additionalData.id}`,
              queryParamsData: this.getSearchData()
            },
          ];
        }
        break;
      }
      default: break;
    }
  }

  getSearchData(): any {
    const search = location.search.substring(1);

    if (search) {
      return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
    }

    return {};
  }

  formatSearchData(data) {
    Object.keys(data).forEach(key => {
      if (data[key] === 'true') {
        data[key] = true;
      }

      if (data[key] === 'false') {
        data[key] = false;
      }
    });

    return data;
  }

  setUrlFilterData(filterName: string, filterValue: any) {
    const urlSearchData = this.getSearchData();

    let filterSearchData = '';

    if (filterValue) {
      urlSearchData[filterName] = filterValue;
    } else {
      delete urlSearchData[filterName];
    }
    Object.keys(urlSearchData).forEach(key => {
      filterSearchData += `${key}=${urlSearchData[key]}&`;
    });
    filterSearchData = filterSearchData.slice(0, -1);

    this.filterPaginationData[filterName] = filterValue;

    this.location.go(
      `${window.location.pathname}?${filterSearchData}`
    );
  }
}
